<template>
<div>
    <header>
        <a href="#" @click.prevent="goBack" class="back"></a>
        <h1>Passwort ändern</h1>
    </header>
    <custom-form :fields="[ { name: 'old_password', title: 'Altes Passwort', type: 'password' }, 
                            { name: 'new_password', title: 'Neues Passwort', type: 'password' }, 
                            { name: 'new_password_repeat', title: 'Neues Password wiederholen', type: 'password' } ]"
                 submitLabel="Speichern"
                 :clearOnSubmit="true"
                 url="users/me/change-password"
                 @submitted="updated" />
</div>
</template>

<script>
import base from 'base.vue'
import customForm from 'components/custom-form.vue'

export default {
    mixins: [ base ],
    components: { customForm },
    methods: {
        updated () {
            base.methods.goBack.call(this)
        }
    }
}
</script>



// WEBPACK FOOTER //
// change-password.vue?8f508302